import { GridColDef } from "@mui/x-data-grid";
import { RenderStatus } from "@/components/Table/Table.renderers";
import { rows } from "../CaseProfileWrapper/CaseDetails/CaseDetails.data";

export const columns: GridColDef<(typeof rows)[number]>[] = [
  {
    field: "P_number",
    headerName: "Project Code",
    filterable: false,
  },
  {
    field: "ShortName",
    headerName: "Project",
    filterable: false,
    width: 400,
  },

  {
    field: "CaseManagerName",
    headerName: "Case Manager",
    filterable: false,
    width: 180,
  },

  {
    field: "PartnerInChargeName",
    headerName: "Partner in Charge",
    filterable: false,
    width: 180,
  },
  {
    field: "AccountName",
    headerName: "Client Name",
    filterable: false,
    width: 180,
  },
  {
    field: "MainProjectIndustry",
    headerName: "Industry Practice",
    filterable: false,
    width: 180,
  },
  {
    field: "MainFunctionalPractice",
    headerName: "Functional Practice",
    filterable: false,
    width: 180,
  },
  {
    field: "Statuses",
    headerName: "Status",
    renderCell: (params) => <RenderStatus value={params.value} />,
    filterable: false,
    sortable: false,
  },
];
